export enum EQueryConfigNames {
    GET_ACTION_LOGS='GET_ACTION_LOGS',
    GET_GOOGLE_SHEET_URL='GET_GOOGLE_SHEET_URL'
}